import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'vf-modal-shell',
    templateUrl: './vf-modal-shell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VfModalShellComponent implements AfterViewInit {
    @ViewChild('modal') modal: ModalDirective;
    @ViewChild('modal', { read: ElementRef }) modalEl: ElementRef<HTMLElement>;

    @Input() title: string = '';
    @Input() failure: boolean = false;
    @Input() saveDisabled: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() maxWidth: string = '400px';
    @Input() scrollable: boolean = false;
    @Input() zIndex: number = 1122;

    private _cancelLabel: string | undefined = undefined;
    @Input() set cancelLabel(v: string | undefined) { this._cancelLabel = v; }
    get cancelLabel(): string { return this._cancelLabel ?? 'Close'; }
    get hasCancelButton(): boolean { return this._cancelLabel != null; }

    private _saveLabel: string | undefined = undefined;
    @Input() set saveLabel(v: string | undefined) { this._saveLabel = v; }
    get saveLabel(): string { return this._saveLabel ?? 'Try again'; }
    get hasSaveButton(): boolean { return this._saveLabel != null; }
    get isDefaults(): boolean { return !this.hasCancelButton && !this.hasSaveButton; }

    private _message = '';
    @Input() set message(v: string | undefined) { if (v != null) { this._message = v; } }

    get displayMessage(): string {
        if (this.failure && this._cancelLabel == null && this._saveLabel == null) {
            return `We couldn't complete this action. Cause: ${this._message}`;
        }

        return this._message;
    }

    @Output() saveClick = new EventEmitter<void>();
    @Output() cancelClick = new EventEmitter<void>();

    private _originalParent: ParentNode | null = null;
    private _backdrop: HTMLDivElement | null = null;

    ngAfterViewInit(): void {
        this.modal.onHide.subscribe(() => {
            const el = this.modalEl?.nativeElement;
            if (this._originalParent && el) {
                this._originalParent.appendChild(el);
                this._originalParent = null;
            }
            if (this._backdrop) {
                this._backdrop.remove();
                this._backdrop = null;
            }
        });
    }

    show(): void {
        if (this.modal?.isShown) { return; }
        const el = this.modalEl?.nativeElement;
        if (el) {
            this._originalParent = el.parentNode;
            document.body.appendChild(el);
        }
        const bd = document.createElement('div');
        bd.style.cssText = `position:fixed;top:0;left:0;width:100%;height:100%;background-color:#000;opacity:0.5;z-index:${this.zIndex - 2}`;
        document.body.appendChild(bd);
        this._backdrop = bd;
        this.modal.show();
    }

    hide(): void {
        this.modal.hide();
    }

    onSave(): void { this.saveClick.emit(); }
    onCancel(): void { this.cancelClick.emit(); }
}
